import './App.css';
import SearchBar from './Components/SearchBar';

function App() {
  
  return (
    <div className="App">
      <SearchBar/>
    </div>
  );
}

export default App;
